(() => {
  const matches = (item, state, omit = '') => Object.entries(state).every(([key, value]) => {
    if (!value || key === omit) return true;
    if (key === 'wall') {
      return item.min !== null && item.max !== null && Number(value) >= item.min && Number(value) <= item.max;
    }
    return item[key] === value;
  });

  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const labels = JSON.parse(root.querySelector('[data-stopfen-labels]').textContent);
    const listNode = root.querySelector('[data-stopfen-item-list]');
    const sourceList = JSON.parse(listNode.textContent);
    const state = { kind: '', shape: '', outer: '', wall: '', color: '' };
    const selects = [...root.querySelectorAll('[data-stopfen-filter]')];
    const shapes = [...root.querySelectorAll('[data-shape-button]')];
    const result = root.querySelector('[data-stopfen-result-count]');
    const chips = root.querySelector('[data-stopfen-chips]');
    const reset = root.querySelector('[data-stopfen-reset]');
    const number = value => value === '' || value === undefined ? null : Number(value);
    const items = [...root.querySelectorAll('[data-stopfen-card]')].map((node, index) => ({
      node, index, kind: node.dataset.kind, shape: node.dataset.shape,
      outer: node.dataset.outer, min: number(node.dataset.wallMin),
      max: number(node.dataset.wallMax), color: node.dataset.color
    }));
    const collator = new Intl.Collator(document.documentElement.lang || 'de', { numeric: true });
    const text = (key, value) => key === 'wall' ? `${String(value).replace('.', ',')} mm` : labels[value] || value;
    const values = Object.fromEntries(Object.keys(state).map(key => {
      const set = new Set(items.map(item => item[key]).filter(Boolean));
      if (key === 'wall') {
        items.forEach(item => {
          if (item.min === null || item.max === null || item.min > item.max) return;
          set.add(String(item.min));
          set.add(String(item.max));
          for (let n = Math.ceil(item.min * 2); n <= Math.floor(item.max * 2); n++) set.add(String(n / 2));
        });
      }
      return [key, [...set].sort((a, b) => key === 'wall' ? Number(a) - Number(b) : collator.compare(a, b))];
    }));

    function update() {
      const visible = items.filter(item => matches(item, state));
      const visibleSet = new Set(visible);
      items.forEach(item => { item.node.hidden = !visibleSet.has(item); });
      selects.forEach(select => {
        const key = select.dataset.stopfenFilter;
        const candidates = items.filter(item => matches(item, state, key));
        [...select.options].slice(1).forEach(option => {
          const count = candidates.filter(item => matches(item, { [key]: option.value })).length;
          option.textContent = `${text(key, option.value)} (${count})`;
          option.disabled = count === 0 && state[key] !== option.value;
        });
        select.value = state[key];
      });
      shapes.forEach(button => {
        button.setAttribute('aria-pressed', String(state.shape === button.dataset.shapeButton));
        const candidates = items.filter(item => matches(item, state, 'shape'));
        button.querySelector('[data-shape-count]').textContent = `(${candidates.filter(item => item.shape === button.dataset.shapeButton).length})`;
      });
      result.textContent = labels.results.replace('__COUNT__', visible.length).replace('__TOTAL__', root.dataset.total);
      root.querySelector('[data-stopfen-empty]').hidden = visible.length > 0;
      chips.replaceChildren();
      Object.entries(state).filter(([, value]) => value).forEach(([key, value]) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'av-stopfen__chip';
        button.dataset.remove = key;
        const label = `${labels[key]}: ${text(key, value)}`;
        button.setAttribute('aria-label', `${labels.remove}: ${label}`);
        button.append(document.createTextNode(label));
        const cross = document.createElement('span');
        cross.setAttribute('aria-hidden', 'true');
        cross.textContent = '\u00d7';
        button.append(cross);
        chips.append(button);
      });
      const active = Object.values(state).filter(Boolean).length + Number(root.dataset.nativeFilterCount || 0);
      root.querySelector('[data-active-count]').textContent = String(active);
      reset.hidden = active === 0;
      listNode.textContent = JSON.stringify({
        ...sourceList, numberOfItems: visible.length,
        itemListElement: visible.map((item, index) => ({ ...sourceList.itemListElement[item.index], position: index + 1 }))
      });
    }

    function change(key, value) {
      state[key] = value;
      if (key === 'shape' || key === 'kind') {
        if (state.outer && !items.some(item => matches(item, { kind: state.kind, shape: state.shape, outer: state.outer }))) state.outer = '';
      }
      update();
    }

    const sort = root.querySelector('[data-stopfen-sort]');
    const storageKey = `av-stopfen-sort:${location.pathname}`;
    const clearNativeFilters = () => {
      try { sessionStorage.removeItem(storageKey); } catch {}
      const url = new URL(location.href);
      [...url.searchParams.keys()].filter(key => key.startsWith('filter.') || key === 'page').forEach(key => url.searchParams.delete(key));
      location.assign(url.href);
    };
    root.querySelector('[data-stopfen-native-reset]')?.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      clearNativeFilters();
    }, true);
    sort.addEventListener('change', () => {
      try { sessionStorage.setItem(storageKey, JSON.stringify(state)); } catch {}
      const url = new URL(location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      location.assign(url.href);
    });
    if (root.dataset.complete !== 'true') return;
    if (!items.length && Number(root.dataset.total) > 0 && new URL(location.href).searchParams.has('page')) {
      const url = new URL(location.href);
      url.searchParams.delete('page');
      location.replace(url.href);
      return;
    }
    selects.forEach(select => {
      const key = select.dataset.stopfenFilter;
      values[key].forEach(value => select.add(new Option(text(key, value), value)));
      select.addEventListener('change', () => change(key, select.value));
    });
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey));
      sessionStorage.removeItem(storageKey);
      if (saved) Object.keys(state).forEach(key => { if (values[key].includes(saved[key])) state[key] = saved[key]; });
    } catch {}
    shapes.forEach(button => button.addEventListener('click', () => change('shape', state.shape === button.dataset.shapeButton ? '' : button.dataset.shapeButton)));
    chips.addEventListener('click', event => {
      const button = event.target.closest('[data-remove]');
      if (button) change(button.dataset.remove, '');
    });
    reset.addEventListener('click', () => {
      if (Number(root.dataset.nativeFilterCount) > 0) {
        clearNativeFilters();
        return;
      }
      Object.keys(state).forEach(key => { state[key] = ''; });
      update();
    });
    root.querySelectorAll('[data-stopfen-controls]').forEach(node => { node.hidden = false; });
    root.querySelector('[data-color-field]').hidden = values.color.length <= 1;
    const disclosure = root.querySelector('[data-stopfen-disclosure]');
    const desktop = matchMedia('(min-width: 901px)');
    disclosure.open = desktop.matches;
    const onResize = event => { disclosure.open = event.matches; };
    desktop.addEventListener('change', onResize);
    root.dataset.inView = 'true';
    const visibility = new IntersectionObserver(([entry]) => { root.dataset.inView = String(entry.isIntersecting); });
    visibility.observe(root);
    root.stopfenCleanup = () => {
      desktop.removeEventListener('change', onResize);
      visibility.disconnect();
    };
    update();
  }
  const start = scope => scope.querySelectorAll('[data-stopfen-selection]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document), { once: true });
  else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-stopfen-selection]').forEach(root => root.stopfenCleanup?.()));
})();

